import React, { useRef, useState } from 'react';
import { Chip, Popper, Fade } from '@material-ui/core';
import { BaseSelect } from './BaseSelect';
import { makeStyles } from '@material-ui/styles';

export const typeOptions = [
    {
        id: 'user_activity',
        title: 'User Activity',
    },
    {
        id: 'logins_by_website',
        title: 'Logins By Website',
    },
];

const useStyles = makeStyles(theme => ({
    popper: {
        zIndex: 1500,
    },
    root: {
        position: 'relative',
        display: 'inline-block',
    },
}));

const ReportTypeFilter = ({
    onChange = () => {},
    onClick = () => {},
    onClose = () => {},
    selected = typeOptions[0],
    open = false,
}) => {
    const classes = useStyles();
    const anchorRef = useRef(null);
    const [opened, setOpened] = useState(open);
    const [type, setType] = useState(selected);

    const handleToggle = () => {
        setOpened(prevOpen => !prevOpen);
        onClick();
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpened(false);
        onClose();
    };

    const handleChangeType = (event, typeOption) => {
        setType(typeOption);
        handleClose(event);
        onChange(typeOption);
    };

    return (
        <div className={classes.root}>
            <Chip
                ref={anchorRef}
                label={`Report type: ${type.title}`}
                color="secondary"
                onClick={handleToggle}
                style={{ marginRight: 5 }}
            />
            <Popper
                open={opened}
                anchorEl={() => anchorRef.current}
                transition
                placement="bottom-end"
                className={classes.popper}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps}>
                        <BaseSelect
                            onClose={handleClose}
                            onChange={handleChangeType}
                            options={typeOptions}
                        />
                    </Fade>
                )}
            </Popper>
        </div>
    );
};

export { ReportTypeFilter };
